export const NAME_HINT = 'is_name_hint_dismissed';
export const COVER_PHOTO_HINT = 'is_cover_photo_hint_dismissed';
export const MESSAGE_HINT = 'is_message_hint_dismissed';
export const PRODUCTS_HINT = 'is_add_product_hint_dismissed';
export const SAVED_HINT = 'is_saved_hint_dismissed';
